import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert } from 'antd';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { ContentBlock, Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import { useGetReservationStateChangeByEmailQuery } from '../../../../../redux/services/reservations.jsx';
import ProtectedEmailLink from '../../../../common/ProtectedEmailLink/ProtectedEmailLink.jsx';
import { RESERVATION_STATUS } from '../../../../../utils/constants/enums.js';
const mapAkciaToState = (akcia) => {
  const norm = (akcia || '').toLowerCase();
  if (norm === 'schvalit') return 'accepted';
  if (norm === 'zamietnut') return 'rejected';
  return null;
};
const ReservationsApprovalPage = () => {
  const [searchParams] = useSearchParams();
  const akcia = searchParams.get('akcia');
  const token = searchParams.get('token');

  const { t } = useTranslation();

  // Map immediately and call the hook right away
  const newState = mapAkciaToState(akcia);

  const { data, error, isError, isSuccess, isLoading } =
    useGetReservationStateChangeByEmailQuery(
      { newState, token },
      { skip: !newState || !token },
    );

  const pageTitle = t('Spracovanie žiadosti o rezerváciu miestnosti');

  useEffect(() => {
    document.title = pageTitle;
  }, []); // Runs on mount

  const invalidParams = !newState || !token;

  return isLoading ? (
    <Spinner />
  ) : (
    <div className="news-detail-page-container">
      <ContentBlock
        contentVisible
        shadow={true}
        title={pageTitle}
        backTo={routes.homePage}
      >
        <div style={{ maxWidth: 800, margin: '10px auto', marginBottom: 10 }}>
          <p>
            {t(
              'Ďakujeme, že ste si našli čas na spracovanie žiadosti o rezerváciu. Nižšie sa nachádzajú informácie o výsledku spracovania žiadosti o rezerváciu miestnosti:',
            )}
          </p>
          {invalidParams && (
            <Alert
              type="warning"
              showIcon
              title={t('Žiadosť o rezerváciu nie je možné spracovať')}
              description={
                <>
                  {t(
                    'Parametre žiadosti chýbajú, alebo sú v nesprávnom tvare. Rezerváciu nie je možné spracovať pomocou e-mailu. Prihláste sa do portálu FRI a',
                  )}{' '}
                  <a
                    href={`${window.location.origin}${routes.cmsReservations}?tab=forApproval`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('rezerváciu schváľte alebo zamietnite')}
                  </a>{' '}
                  {t('v module rezervácií.')}
                </>
              }
              style={{ marginTop: 12 }}
            />
          )}

          {!invalidParams &&
            isError &&
            (error.data.reason === 'token_not_found' ||
              error.data.reason === 'reservation_not_found') && (
              <Alert
                type="warning"
                showIcon
                title={t('Žiadosť o rezerváciu nie je možné spracovať')}
                description={t(error.data.error)}
                style={{ marginTop: 12, marginBottom: 12 }}
              />
            )}

          {!invalidParams && isSuccess && (
            <Alert
              type="success"
              showIcon
              title={data?.message || t('Rezervácia bola úspešne spracovaná.')}
              description={
                <>
                  {t('Rezervácia bola')}{' '}
                  <strong>
                    {newState === RESERVATION_STATUS.ACCEPTED.STATE
                      ? t('schválená')
                      : t('zamietnutá')}
                  </strong>
                  {'. '}
                  {t(
                    'O výsledku spracovania žiadosti bude žiadateľ informovaný e-mailom.',
                  )}
                </>
              }
              style={{ marginTop: 12, marginBottom: 12 }}
            />
          )}

          {!invalidParams &&
            isError &&
            (error.data.reason === 'invalid_state' ||
              error.data.reason === 'state_not_changable') && (
              <Alert
                type="warning"
                showIcon
                title={t('Žiadosť o rezerváciu nie je možné spracovať')}
                description={t(error.data.error)}
                style={{ marginTop: 12 }}
              />
            )}
          <p style={{ marginTop: 12, paddingBottom: 20 }}>
            {t(
              'V prípade akýchkoľvek otázok alebo problémov neváhajte kontaktovať',
            ) + ' '}
            <ProtectedEmailLink
              user={'portal-admin'}
              domain={'fri.uniza.sk'}
              text={t('správcu portálu')}
            />
            .
          </p>
        </div>
      </ContentBlock>
    </div>
  );
};

export default ReservationsApprovalPage;
